/**
 * @file Responsive video
 *
 * Control video presented to user dependent on the window width.
*/

export default class ResponsiveVideo {
    /**
     * Class constructor
     *
     * @arg {object} - `el` Responsive video element
    */
    constructor (el) {
        if (!el) return;
        this.el = el;
        this.breakpoint = 767;
        this.playBackButton = el.nextElementSibling;
        this.videoPaused = false;

        this.init();

        if (this.playBackButton && this.playBackButton.classList.contains('js-toggle-playback')) {
            this.initPlaybackBtn();
        }

        const mq = window.matchMedia(`(max-width: ${this.breakpoint}px)`);
        mq.addEventListener('change', () => {
            this.init();
        });
    }

    init () {
        const windowWidth = window.innerWidth;
        if (windowWidth > this.breakpoint) {
            if (this.el.dataset.desktopVideo) {
                this.addSourceToVideo(
                    this.el,
                    this.el.dataset.desktopVideo
                );
            }
        } else {
            if (this.el.dataset.mobileVideo) {
                this.addSourceToVideo(
                    this.el,
                    this.el.dataset.mobileVideo
                );
            } else if (this.el.dataset.desktopVideo) {
                this.addSourceToVideo(
                    this.el,
                    this.el.dataset.desktopVideo
                );
            }
        }
    }

    addSourceToVideo (el, src) {
        el.src = src;
    }

    initPlaybackBtn () {
        this.playBackButton.addEventListener('click', () => {
            const pauseIcon = this.playBackButton.querySelector('.js-toggle-playback-pause');
            const playIcon = this.playBackButton.querySelector('.js-toggle-playback-play');
            const childVideo = this.el.querySelector('video');
            if (this.videoPaused) {
                if (childVideo) {
                    childVideo.play();
                } else {
                    this.el.play();
                }
                pauseIcon.classList.remove('hidden');
                playIcon.classList.add('hidden');
            } else {
                if (childVideo) {
                    childVideo.pause();
                } else {
                    this.el.pause();
                }
                pauseIcon.classList.add('hidden');
                playIcon.classList.remove('hidden');
            }
            this.videoPaused = !this.videoPaused;
        })
    }
}
